












































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';

@Component
export default class UserView extends Vue {
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public items: Common.User[] = new Array();
  public params: Common.UserQuery = new Common.UserQuery();
  public importQuery = new Common.UserImportQuery('ユーザー',false);//new Common.ImportQuery('ユーザー', 'User');
  public exportQuery = new Common.UserExportQuery('ユーザー', this.params,this.$api.license.mfaEnabled);

  public sortOptions: any = [
    { value: 'id', text: 'ユーザーID' },
    { value: 'name', text: 'ユーザー名' },
  ];

  public listItems: Common.GroupMember[];

  public created(){
    if(this.$api.license.mfaEnabled == false){
      this.listCaptions = ['ユーザー名', 'ユーザーID','利用区分', 'ユーザー区分', '代理ユーザー'];
      this.listWidths = [200, 200,150, 200, 150];
      this.listSlots =['grid0','grid1','grid2','grid3','','grid4'];
    }else{
      this.listCaptions = ['ユーザー名', 'ユーザーID','利用区分', 'ユーザー区分', 'ライセンス区分', '代理ユーザー'];
      this.listWidths = [200, 200,150, 200, 200, 150];
      this.listSlots =['grid0','grid1','grid2','grid3','grid4','grid5'];
    }

    this.$api.formatter.ensureListLoaded('group').then(()=>{
      this.listItems = this.$api.formatter.getOptions('group').map(obj => new Common.GroupMember(null, obj.value));
    });    
  }

  public async onCreate(obj: Common.User){
    // 運用管理機能を使わない場合、利用ユーザーの初期値はシステム管理者とする
    //利用ユーザーを初期値として設定する
    if (this.$api.useOperationFunction && this.$api.formatter.getOptions('group').find(obj=>obj.value == 'operators')) 
      obj.groups.push(new Common.GroupMember(null, 'operators'));
    else if ((this.$api.useOperationFunction == false) && this.$api.formatter.getOptions('group').find(obj=>obj.value == 'administrators')) 
      obj.groups.push(new Common.GroupMember(null, 'administrators'));
    return Promise.resolve(obj);    
  }
}
